import React, { useState } from 'react'
import { getBEMCls } from '@/utils/classname'
import { Expaned } from '@/components/layout/layout'
import Button from '@/components/button/button'

import './purchase-supplier.scss'
import PurchaseSupplierTable from './modules/purchase-supplier-table/purchase-supplier-table'
import { showLayer } from '@/utils/layer'
import PurchaseSupplierForm from './modules/purchase-supplier-form/purchase-supplier-form'
import SearchInput from '@/components/search-input/search-input'
import { supplierModel } from './model'

const PurchaseSupplier = () => {
    const getCls = (e?: string, m?: string) => getBEMCls('purchase-supplier', e, m)

    const [refreshStatus, setRefreshStatus] = useState<boolean>(false)

    return (
        <>
            <Expaned className={getCls()}>
                <div className={getCls('header')}>
                    <Button
                        style={{
                            marginRight: '16px',
                        }}
                        types="default"
                        onClick={() => {
                            showLayer(
                                <PurchaseSupplierForm
                                    refresh={() => {
                                        setRefreshStatus(!refreshStatus)
                                    }}
                                />,
                            )
                        }}
                    >
                        添加供货商
                    </Button>
                    <SearchInput
                        isExpaned={false}
                        placeholder="请输入关键词搜索"
                        onDelete={() => {
                            supplierModel.setKeyWord('')
                        }}
                        onSearch={val => {
                            supplierModel.setKeyWord(val)
                        }}
                    />
                </div>
                <Expaned data-row className={getCls('content')}>
                    <PurchaseSupplierTable refreshStatus={refreshStatus} />
                </Expaned>
            </Expaned>
        </>
    )
}

export default PurchaseSupplier
